import React from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import { styled } from "@mui/system";
import studentDB from "../assets/studentDB.jpg";
import inventoryDB from "../assets/inventoryDB.png";
import hospitalDB from "../assets/hospitalDB.jpg";

// Page Wrapper with White Background
const Section = styled("section")({
  background: "#FFFFFF",
  minHeight: "115vh",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "60px 20px",
  position: "relative",
});

// Gradient Container (Moved Up)
const GradientContainer = styled(Container)({
  background: "linear-gradient(to right, #00c9a7, #0072ff)",
  padding: "40px",
  borderRadius: "20px",
  boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.2)",
  maxWidth: "800px",
  textAlign: "center",
  position: "relative", // Moves container upward
  marginBottom: "55px",
});


const DatabaseManagement = () => {
  return (
    <Section>
      {/* UI/UX Design Main Section */}
      <GradientContainer>
        <Typography variant="h2" sx={{ fontWeight: "bold", color: "#FBFFFE" }}>
          Database Management
        </Typography>
        <Typography variant="body1" sx={{ marginTop: 2, color: "#FBFFFE" }}>
          Master Database Management principles and create visually appealing,
          user-friendly interfaces.
        </Typography>
        <Box sx={{ marginTop: 3 }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#FAA916",
              color: "#FBFFFE",
              "&:hover": { backgroundColor: "#e08c00" },
            }}
          >
            Get Started
          </Button>
        </Box>
      </GradientContainer>

      {/* Recommended Projects Section */}
      <Typography
        variant="h3"
        sx={{ fontWeight: "bold", marginBottom: 4, color: "#333" }}
      >
        Recommended Projects
      </Typography>

      <Grid container spacing={4} justifyContent="center" width="100%">
        {/* Project 1 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: 400,
              width: "420px",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="230"
              image={studentDB}
              alt="Online Restaurant Ordering System"
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                Student Information Management System
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1, color: "#555" }}
              >
                A robust database system to manage student profiles, attendance, grades, and course registration using PostgreSQL and Node.js.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Project 2 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: 400,
              width: "420px",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="230"
              image={inventoryDB}
              alt="Online Restaurant Ordering System"
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                Inventory Management System
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1, color: "#555" }}
              >
                A full-stack web application to track product stock levels, suppliers, and purchase history using MySQL and Express.js.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Project 3 */}
        <Grid item xs={12} sm={6} md={4}>
          <Card
            sx={{
              height: 400,
              width: "420px",
              display: "flex",
              flexDirection: "column",
              borderRadius: 3,
              boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
            }}
          >
            <CardMedia
              component="img"
              height="230"
              image={hospitalDB}
              alt="Online Restaurant Ordering System"
            />
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                Hospital Patient Record System
              </Typography>
              <Typography variant="body2" color="text.secondary">
              A secure and scalable database application for storing and retrieving patient data, appointments, and medical history using MongoDB.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Section>
  );
};

export default DatabaseManagement;
